import PropTypes from 'prop-types'
import React from 'react'
import { Image, Label } from 'semantic-ui-react'

import { Card, CardContent, CardDescription } from 'components/Card'
import { Condition } from 'components/Condition'

export const IntegrationCard = ({ label, image, isSelected, isActive, onClick }) => (
  <Card active={isSelected} onClick={onClick} link>
    <Image
      centered
      src={image}
      style={{ padding: '1.25rem 0', width: '4rem', height: '4rem', boxSizing: 'content-box' }}
    />
    <CardContent textAlign="center">
      <CardDescription>
        <strong>{label}</strong>
      </CardDescription>
      <Condition.True condition={isActive}>
        <Label color="green" attached="top right" size="small">
          Active
        </Label>
      </Condition.True>
    </CardContent>
  </Card>
)

IntegrationCard.propTypes = {
  label: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntegrationCard.js